import { Toaster as Sonner } from "sonner";

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      duration={1500}
      className="toaster group"
      closeButton={true} // Enable the close button
      toastOptions={{
        classNames: {
          closeButton: "custom-close-button", // Custom class for the close button
        },
      }}
      {...props}
    />
  );
};

export { Toaster };